var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('nav-header',{ref:"headers",on:{"handleLogin":_vm.handleLogin}}),_c('convert-list',{attrs:{"isLogin":_vm.isLogin,"convertType":_vm.convertType}}),_c('handle-or-score'),_c('copy-right-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }